import { Component, Injectable } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { FormValidator } from 'src/app/shared/validators/Validator';
import Swal from 'sweetalert2';
import { IntakeService } from '../../../services/previdencia/intake.service';
import { SocialSecurityService } from '../../../services/previdencia/social-security.service';
import { NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ContributionFilter } from 'src/app/shared/classe/contribution-filter.model';
import { ModalDetalheAporteComponent } from 'src/app/shared/modals/modal-detalhe-aporte/modal-detalhe-aporte.component';
import { faEye, faFileExcel, faFilePdf } from '@fortawesome/free-solid-svg-icons';

@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
readonly DELIMITER = '-';

  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        year: parseInt(date[0], 10),  // O ano vai ser o primeiro
        month: parseInt(date[1], 10), // O mês vai ser o segundo
        day: parseInt(date[2], 10),   // O dia vai ser o último
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date 
      ? date.year + this.DELIMITER + this.pad(date.month) + this.DELIMITER + this.pad(date.day) 
      : null;
  }

  private pad(n: number): string {
    return n < 10 ? '0' + n : '' + n;
  }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER = '-';  // Para exibir com '-'

  parse(value: string): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date 
      ? this.pad(date.day) + this.DELIMITER + this.pad(date.month) + this.DELIMITER + date.year 
      : '';
  }

  private pad(n: number): string {
    return n < 10 ? '0' + n : '' + n;
  }
}

export function dateValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    const regex = /^\d{4}-\d{2}-\d{2}$/;

    if (value && regex.test(value)) {
      return null; // A data está no formato correto
    }
    return { 'invalidDate': true }; 
  };
}


@Component({
  selector: 'app-solicitacao-aporte',
  templateUrl: './solicitacao-aporte.component.html',
  styleUrls: ['./solicitacao-aporte.component.css'],
  providers: [
      { provide: NgbDateAdapter, useClass: CustomAdapter },
      { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter  },
    ],
})
export class SolicitacaoAporteComponent {
  dt: any = 2;
  dtm: any = 30;
  form: FormGroup = new FormGroup({
    paymentDate: new FormControl(null, [Validators.required, this.formValidator.isBetweenNextDayMonthAgo, this.formValidator.isNotWeekendDay]),
    value: new FormControl(null, [Validators.required, Validators.min(1)]),
    originValue: new FormControl(null),
    originValueId: new FormControl(null),
  });
  loadingIntake: boolean = false;
  loadingIntakeValue: boolean = false;
  intakeHistory: any = null;
  twelvePercentegeSuccess: boolean = false;
  filter: any = { page: 0, limit: 10 };
  intakeFromThisMonth: any = 0;
  originValues!: any[];
  historicoAporte: boolean = false;
  error: boolean = false;
  noContent: boolean = false;
  intakeValue: any = 0;

  loading: boolean = false;
  diaLimite: boolean = false;
  Today: Date = new Date();
  minDate: string;
  maxDate: string;
  invalido: boolean = false;

  formGroup: FormGroup = new FormGroup({
    Num_Matr_Partf: new FormControl(null),
    Dat_Prvpg_Blpgt: new FormControl(null, [dateValidator()]),
    Vlr_Prvst_Iblpgt: new FormControl(null),
    Origem: new FormControl(null),
    TipoFatura: new FormControl("Aporte"),
  });

  formGroupMinhasSolicitacoes: FormGroup = new FormGroup({
    finalDate: new FormControl(null),
    initialDate: new FormControl(null),
    itemsPerPage: new FormControl(5),
    page: new FormControl(0),
    totalFiltered: new FormControl(),
  });
  origemAporte: any[] = [];
  feriado: any;

  constructor(private socialSecurityService: SocialSecurityService, private intakeService: IntakeService, private formValidator: FormValidator, private modalService: NgbModal) {
    this.minDate = this.formatDate(new Date(this.Today.getTime() + 2 * 24 * 60 * 60 * 1000));
    var lastDayOfMonth = new Date(this.Today.getFullYear(), this.Today.getMonth() + 1, 0);
    let firstDayOfMonth = new Date(this.Today.getFullYear(), this.Today.getMonth(), 1);
    let utilDay = 0;
    let lastThreeUtilDays = [];
    let firstThreeUtilDays = [];

    this.socialSecurityService.ValidaListaFeriado().subscribe((res: any) => {
      console.log(res)
      this.feriado = res
    })

    this.load()

    // Regra de limitar o vencimento até 3 dias úteis antes do final do mês
    while (utilDay < 3) {
      if (lastDayOfMonth.getDay() !== 6 && lastDayOfMonth.getDay() !== 0) {
        lastThreeUtilDays.push(new Date(lastDayOfMonth));
        utilDay += 1;
      }
      lastDayOfMonth.setDate(lastDayOfMonth.getDate() - 1);
    }
    this.maxDate = this.formatDate(lastThreeUtilDays[0]);
    utilDay = 0;

    // Regra de solicitar boleto apenas após o 3º dia útil do mês
    while (utilDay < 3) {
      if (firstDayOfMonth.getDay() !== 6 && firstDayOfMonth.getDay() !== 0) {
        firstThreeUtilDays.push(new Date(firstDayOfMonth));
        utilDay += 1;
      }
      firstDayOfMonth.setDate(firstDayOfMonth.getDate() + 1);
    }

    // Verifica se hoje está nos primeiros ou últimos 3 dias úteis do mês
    if (firstThreeUtilDays.some(date => date.getDate() === this.Today.getDate()) ||
        lastThreeUtilDays.some(date => date.getDate() === this.Today.getDate())) {
      this.diaLimite = true;
    }

    // Regra para limitar a data de solicitação entre 24/11 e 05/01 (final de ano)
    if (this.Today.getMonth() === 11 || this.Today.getMonth() === 0) {
      const currentYear = new Date().getFullYear();
      let startBlock = new Date(currentYear, 11, 24);
      let endBlock = new Date(currentYear + 1, 0, 5);

      if (this.Today >= startBlock && this.Today <= endBlock) {
        this.diaLimite = true;
      }
    }

    if (this.maxDate < this.minDate) {
      this.diaLimite = true;
    }

    socialSecurityService.getOrigensAporte().subscribe((res: any) => {
      this.origemAporte = res.map((item: any) => ({
        nome: item.name,
        id: item.id
      }));
    });

    this.intakeService.getThisMonthIntakeValue().subscribe({
      next: (res: any) => {
        this.intakeFromThisMonth = res;
        this.loading = false;
      },
      error: (error: any) => (this.loading = false)
    });

    this.getBaseInfo();
    this.loadIntakeValue();
    this.getOrigemValue();
    this.form.get('value')?.valueChanges.subscribe(x => {
      setTimeout(() => {
        if (x >= 10000) {
          this.form.get('originValue')?.setValidators([Validators.required]);
          this.form.get('originValue')?.updateValueAndValidity();
        }
      }, 1500);
    });
  }



  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Meses começam do zero
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  disableTyping(event: KeyboardEvent) {
    event.preventDefault();
  }

  openCalendar(event: FocusEvent) {
    const input = event.target as HTMLInputElement;
    input.showPicker();
    if (this.minDate > this.maxDate) {
      Swal.fire('Aviso de data', 'Não é possivel solicitar boletos em fechamento de mês!', 'warning')
    }
  }


  GenerateInvoice() {
    if (this.formGroup.controls['Dat_Prvpg_Blpgt']?.value == null || this.formGroup.controls['Vlr_Prvst_Iblpgt'].value == 0) {
      Swal.fire('Solicitação de Boleto', 'Favor preencher os campos obrigatórios', 'warning')
      this.invalido = true;
      return;
    }
    if (this.formGroup.controls['Origem'].value == null) {
      this.formGroup.patchValue({
        Origem: 0
      });
    }
    this.loading = true;
    this.socialSecurityService.PostGenerateInvoice(this.formGroup.value).subscribe((res: any) => {
      if (res) {
        this.loading = false
        Swal.fire('Solicitação de Aporte', 'Estamos felizes em informar que sua solicitação foi concluída com sucesso. O boleto de aporte estará disponível na aba Boletos -> Previdência e Empréstimo dentro de até 48 horas úteis.', 'success')
      } else {
        this.loading = false
        Swal.fire('Solicitação de Aporte', 'Houve um erro ao gerar o boleto', 'error')
      }
    })
  }

  ValidateExistence() {
    const button = document.getElementById('btnSubmit');
    this.socialSecurityService.ValidateExistenceAporte(this.formGroup.controls['Dat_Prvpg_Blpgt'].value).subscribe((res: any) => {
      if (res.length > 0) {
        Swal.fire('Solicitação de Aporte', 'Já existe um boleto em aberto para a data solicitada!', 'warning')
        button?.setAttribute('disabled', '');
      } else {
        button?.removeAttribute('disabled');
      }
    })
  }

  getOrigemValue() {
    this.intakeService.getOriginValue().subscribe((res: any) => { this.originValues = res; })
  }
  getBaseInfo() {
    this.loadingIntake = true;
    this.socialSecurityService.getLastIntake(this.filter).subscribe({
      next:
        (res: any) => {
          if (res.status != 204) {
            this.intakeHistory = res.body;
          } else {
            this.noContent = true
          }
          this.loadingIntake = false;
        },
      error:
        (err: any) => {
          this.loadingIntake = false; this.error = true;
        }
    }
    )
  }
  loadIntakeValue() {
    this.loadingIntakeValue = true;
    this.socialSecurityService.getIntakeValue().subscribe({
      next: (res: any) => {
        if (res >= 0) {
          // this.form.get('value').patchValue(res);
          this.intakeValue = res;
          this.loadingIntakeValue = false;
        } else {
          this.loadingIntakeValue = false;
          this.twelvePercentegeSuccess = true;
          // this.toast.success("12%(IR) já alcançado!", "Sucesso");
        }
      },
      error: (error: any) => {
        this.loadingIntakeValue = false;
      }
    })
  }
  historicoAportes() {
    this.historicoAporte = true;
  }


   model!: NgbDateStruct;
    
   isDisabled = (date: NgbDateStruct) => {
    const currentDate = new Date();
    const selectedDate = new Date(date.year, date.month - 1, date.day);

    // Verifica se a data está no próximo mês
    const nextMonth = new Date(currentDate);
    nextMonth.setMonth(currentDate.getMonth() + 1);
    const isNextMonth = selectedDate.getFullYear() === nextMonth.getFullYear() && selectedDate.getMonth() === nextMonth.getMonth();

    // Desabilita se a data for no passado
    const isPastDate = selectedDate < currentDate;

    // Verifica se é final de semana (sábado = 6, domingo = 0)
    const isWeekend = selectedDate.getDay() === 6 || selectedDate.getDay() === 0;

    // Verifica o último dia útil do mês
    const lastDayOfMonth = new Date(date.year, date.month, 0).getDate();

    // Calcula os últimos 3 dias úteis do mês
    let lastThreeWeekdays = [];
    let daysLeft = 3;
    for (let i = lastDayOfMonth; i >= 1 && daysLeft > 0; i--) {
        const checkDate = new Date(date.year, date.month - 1, i);
        if (checkDate.getDay() !== 6 && checkDate.getDay() !== 0) { // Se não for final de semana
            lastThreeWeekdays.push(i);
            daysLeft--;
        }
    }

    const isLastThreeDays = lastThreeWeekdays.includes(date.day);

    // Verifica se já passou das 15:30
    const currentHour = currentDate.getHours();
    const currentMinutes = currentDate.getMinutes();
    const after1530 = currentHour > 15 || (currentHour === 15 && currentMinutes > 30);

    // Calcula o próximo dia útil disponível
    const getNextBusinessDay = (daysToAdd: number) => {
        let nextDate = new Date(currentDate);
        while (daysToAdd > 0) {
            nextDate.setDate(nextDate.getDate() + 1);
            if (nextDate.getDay() !== 6 && nextDate.getDay() !== 0) { // Se for dia útil, reduz contador
                daysToAdd--;
            }
        }
        return nextDate;
    };

    const nextAvailableDate = getNextBusinessDay(after1530 ? 2 : 0);
    const isBeforeNextAvailableDate = selectedDate < nextAvailableDate;

    // Verifica se a data selecionada é um feriado
    const isHoliday = this.feriado.some((holiday: any) => {
        const holidayDate = new Date(holiday);
        return holidayDate.getFullYear() === selectedDate.getFullYear() &&
               holidayDate.getMonth() === selectedDate.getMonth() &&
               holidayDate.getDate() === selectedDate.getDate();
    });

    // Retorna true se a data for inválida (passada, final de semana, feriado, etc)
    return isPastDate || isWeekend || isLastThreeDays || isNextMonth || isBeforeNextAvailableDate || isHoliday;
};
    



myContributionRequests: any;
lista: any;
loadingPdf: boolean = false;
loadingCsv: boolean = false;
faPdf = faFilePdf;
faExcel = faFileExcel;
today = new Date();
faEye = faEye;
loadingHistorico: boolean = true;

load() {
    this.loadingHistorico = true;
    this.socialSecurityService.getIntakes(this.formGroupMinhasSolicitacoes.value).subscribe((res: any) => {
      this.myContributionRequests = res.items;
      this.loadingHistorico = false;
      this.formGroupMinhasSolicitacoes.patchValue(res);
      this.lista = res;
    })
  }
  printCsv() {
    let contributionFilter = new ContributionFilter(0, 0, this.formGroupMinhasSolicitacoes.value.initialDate, this.formGroupMinhasSolicitacoes.value.finalDate, 'aportes');
    this.socialSecurityService.getContributionsCsv(contributionFilter).subscribe(
      (data: Blob) => {
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        a.download = "Extrato de Aportes.csv";
        a.href = URL.createObjectURL(data);
        a.target = '_blank';
        a.click();
        document.body.removeChild(a);
      });
  }
  visualizarAporte(details: any) {
    const modalRef = this.modalService.open(ModalDetalheAporteComponent, { windowClass: 'carteirinha-modal-size', centered: true });
    modalRef.componentInstance.details = details;
  }
  onChangeQuantidadeItens(quantidade: number) {
    this.formGroupMinhasSolicitacoes.get('itemsPerPage')?.setValue(quantidade);
    this.formGroupMinhasSolicitacoes.get('page')?.setValue(0);
    this.socialSecurityService.getIntakes(this.formGroupMinhasSolicitacoes.value).subscribe((res: any) => {
      this.myContributionRequests = res.items;
      this.loadingHistorico = false;
      this.formGroupMinhasSolicitacoes.patchValue(res);
    })
  }
  onChangePagination(page: number) {
    this.formGroupMinhasSolicitacoes.get('page')?.setValue(page);
    this.socialSecurityService.getIntakes(this.formGroupMinhasSolicitacoes.value).subscribe((res: any) => {
      this.myContributionRequests = res.items;
      this.loadingHistorico = false;
    })
  }
}
